import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { xlsxExport } from "../../../utils/xlsxExport";
import PropTypes from "prop-types";

export const XLSX = ({ colHeaders, data, columns }) => {
  return (
    <a
      className="download"
      onClick={() =>
        xlsxExport({ data, headers: colHeaders, fileName: "ikizmet_raw_data", columns })
      }
    >
      <FontAwesomeIcon icon={faDownload} /> Download As Excel
    </a>
  );
};

XLSX.propTypes = {
  colHeaders: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(PropTypes.array),
  columns: PropTypes.arrayOf(PropTypes.array)
};

/*find string numbers in data array and convert it to numbers*/
export function getFormattedData(data, currency = "") {
  let formattedData = data.map((rowArray) => {
    return rowArray.map((row) => {
      let cleanedRow = row.replace(currency, "").replace(/[%,]/, "");
      let cleanedRowToNum = Number(cleanedRow);

      if (!isNaN(cleanedRowToNum)) {
        return cleanedRowToNum;
      }
      return row;
    });
  });
  return formattedData;
}

/*rewrite each row with values in original data array*/
export function getScopedSlots(data, colHeaders) {
  let scopedSlots = {};
  const groupByFields = ["Location", "Region", "Division", "District"];

  colHeaders.forEach((header, index) => {
    scopedSlots[header] = (item) => {
      // loose comparison is used, because location name can be number string converted to number
      let row = data.find((rowArray) => groupByFields.some((field) => rowArray[0] == item[field]))[
        index
      ];
      return <td>{row}</td>;
    };
  });

  return scopedSlots;
}

export function makeColHeadersUnique(colHeaders) {
  return colHeaders.map((header, index) => {
    if (colHeaders.indexOf(header) !== index) {
      header += index;
      return header;
    }
    return header;
  });
}

export const dataForTables = {
  tableFilter: false,
  sorter: true,
  pagination: false
};
